module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Shovel-39405ef099b183e52e0f62b7b95f6248.svg";